export function toStringValue(element: HTMLInputElement): string {
  return element.type === "checkbox"
    ? element.checked
      ? "on"
      : "off"
    : element.value;
}
